{
  "header": {
    "title": "Paramètres",
    "description": "Gérez vos préférences, notifications et paramètres d’accès pour personnaliser votre expérience sur Chirpee"
  },
  "tabs": {
    "workplace": {
      "title": "Lieu de travail",
      "logo": "Logo du lieu de travail",
      "changeLogo": "Changer le logo",
      "logoEmptyState": "Aucun logo téléversé",
      "logoValidation": {
        "invalidFormat": "Veuillez choisir une image PNG, JPEG, GIF ou WebP.",
        "fileTooLarge": "L’image doit faire au plus 5 Mo.",
        "dimensionsTooLarge": "L’image doit mesurer au plus 4096 × 4096 pixels.",
        "loadFailed": "Impossible de lire cette image. Essayez un autre fichier."
      },
      "logoUploadErrorFallback": "Échec du téléversement du logo. Veuillez réessayer.",
      "maxSize": "Max. 5 Mo · max. 4096 × 4096 px",
      "format": "PNG, JPEG, GIF ou WebP",
      "worplaceNameInput": {
        "label": "Nom du lieu de travail",
        "placeholder": "Nom du lieu de travail"
      },
      "companyIndustryInput": {
        "label": "Secteur d'activité de l’entreprise",
        "placeholder": "Secteur d'activité",
        "industries": {
          "technology": "Technologie",
          "professionalServices": "Services professionnels",
          "financialServices": "Services financiers",
          "consulting": "Consulting",
          "softwareDevelopment": "Développement de logiciels",
          "digitalMarketing": "Marketing digital",
          "mediaAndCommunications": "Médias et communications",
          "eCommerce": "Commerce électronique",
          "healthTech": "Technologie de la santé"
        }
      },
      "languguages": {
        "title": "Langues prises en charge",
        "helpText": "Texte d’aide"
      },
      "applyButton": "Appliquer les modifications"
    },
    "userManagement": {
      "title": "Gestion des utilisateurs",
      "userInput": {
        "placeholder": "Rechercher des utilisateurs"
      },
      "roleDropdown": {
        "triggerLabel": "Rôle",
        "options": {
          "admin": "Administrateur",
          "people_experience": "Expérience humaine",
          "user": "Utilisateur"
        }
      }
    },
    "integrations": {
      "title": "Intégrations",
      "options": {
        "hris": { "label": "SIRH" },
        "sso": { "label": "Authentification unique (SSO)" },
        "messagingConnected": { "label": "Outil de communication" }
      }
    },
    "billing": {
      "title": "Facturation",
      "planSection": {
        "title": "Votre abonnement",
        "status": {
          "active": "Actif"
        },
        "usersCount": {
          "title": "Utilisateurs mensuels"
        },
        "amount": {
          "title": "Montant du renouvellement",
          "cost": "par utilisateur"
        },
        "charge": {
          "title": "Prochain prélèvement"
        },
        "cycle": {
          "title": "Cycle de facturation"
        }
      },
      "invoiceInformationSection": {
        "title": "Informations de facturation",
        "name": "Nom de l’entreprise",
        "email": "Email de facturation",
        "address": "Adresse de l’entreprise",
        "taxId": "Identifiant fiscal",
        "paymentMethod": "Mode de paiement",
        "paymentDate": "Date du dernier paiement",
        "editButton": "Modifier",
        "portalError": "Impossible d’ouvrir le portail de facturation. Veuillez réessayer."
      },
      "invoiceHistorySection": {
        "title": "Historique des factures",
        "viewButton": "Voir",
        "downloadButton": "Télécharger",
        "emptyState": {
          "title": "Aucune facture pour le moment",
          "description": "Les factures apparaîtront ici après votre premier paiement réussi."
        }
      },
      "errorState": {
        "title": "Impossible de charger les informations de facturation",
        "description": "Actualisez la page et réessayez."
      }
    },
    "logs": {
      "title": "Journaux d’audit",
      "table": {
        "title": "Activité récente",
        "acitivityDropdown": {
          "triggerLabel": "Toutes les activités"
        },
        "usersDropdown": {
          "triggerLabel": "Tous les utilisateurs"
        },
        "exportButton": "Exporter les journaux"
      }
    }
  }
}
